import Accordion from '@/common/components/Accordion';
import { InfoIcon } from 'lucide-react';
import { CardProductLimit } from '../../../types/equipments.type';
import { ApplicableProduct } from './ApplicableProduct';
import { useProductsConsumptionInCurrentPeriodLimits } from '@/common/hooks/queries/useProductsConsumptionInCurrentPeriodLimits';

interface ApplicableProductsProps {
  cardId?: string;
  applicableProducts: CardProductLimit[];
}

export const ApplicableProducts = ({
  cardId,
  applicableProducts,
}: ApplicableProductsProps) => {
  const {
    data: productsConsumptionInCurrentPeriodLimits,
    isPending: productsConsumptionInCurrentPeriodLimitsIsPending,
  } = useProductsConsumptionInCurrentPeriodLimits({ cardId })

  return (
    <Accordion
      name="applicable_products"
      head={(
        <p>Produtos aplicáveis</p>
      )}
      body={(
        <div className="flex w-full flex-col gap-y-4">
          <div className="flex w-full items-center gap-x-2">
            <InfoIcon strokeWidth={1} className="text-yellow-600" />
            <div>
              <p className="font-bold text-[10px] leading-3">
                Ao selecionar um Produto, todos os não selecionados serão bloqueados para consumo
              </p>

              <p className="font-light text-[10px] italic leading-3">
                Certifique-se de adicionar as restrições para todos os produtos que desejar consumir.
              </p>
            </div>
          </div>

          {applicableProducts.map((applicableProduct, index) => {
            const limitByTransaction = !!applicableProduct.credit_limit_per_transaction || !!applicableProduct.quantity_limit_per_transaction;
            const limitByPeriod = !!applicableProduct.credit_limit_per_period || !!applicableProduct.quantity_limit_per_period;

            return (
              <ApplicableProduct
                key={applicableProduct.id}
                applicableProduct={applicableProduct}
                limitByTransaction={limitByTransaction}
                limitByPeriod={limitByPeriod}
                index={index}
                productConsumptionInCurrentPeriodLimits={productsConsumptionInCurrentPeriodLimits?.[applicableProduct.product.id]}
                productsConsumptionInCurrentPeriodLimitsIsPending={productsConsumptionInCurrentPeriodLimitsIsPending}
              />
            );
          })}
        </div>
      )}
    />
  );
};
